module.exports = __webpack_public_path__ + "static/media/20170806_03day_0112AT.24ddf1d9.jpg";